import * as e from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/Wrench.es.js";
const o = e.forwardRef((r, c) => /* @__PURE__ */ e.createElement(t, { ref: c, ...r, weights: n }));
o.displayName = "WrenchIcon";
const s = o;
export {
  s as Wrench,
  o as WrenchIcon
};
